export default "__VITE_ASSET__W5x2kF0b__"